import { useAuth } from "@/components/context/AuthProvider"
import Typography from "@/components/typography/Typography"
import { useUpdateUserProfileMutation } from "@/graphql"
import { Checkbox, Col, Row, message } from "antd"
import { CheckboxChangeEvent } from "antd/es/checkbox"
import { FC, useState } from "react"
import "./ZoomNotice.less"
import gearsImg from "./assets/gears.png"

const { Title, Paragraph, Text } = Typography

const ZoomNotice: FC = () => {
  const { user } = useAuth()

  const userId = user?.userProfile?.data?.id
  const [updateIsZoomNoticeShown, { loading }] = useUpdateUserProfileMutation()

  // The signed-in user's profile already carries the flag; no separate fetch needed.
  const [isChecked, setIsChecked] = useState(!!user?.userProfile?.data?.attributes?.isZoomNotice)

  const onCheckboxChange = async (e: CheckboxChangeEvent) => {
    const checked = e.target.checked
    setIsChecked(checked)
    if (!userId) return
    try {
      await updateIsZoomNoticeShown({
        variables: {
          id: userId,
          data: { isZoomNotice: checked },
        },
      })
    } catch (error: any) {
      setIsChecked(!checked) // rollback
      message.error(error.message)
    }
  }

  return (
    <Row justify={"center"} className={"zoom-notice-wrapper"}>
      <Col span={22}>
        <Title level={5} centered color={"white"}>
          <span className={"w300"}>{"Improve Your"}</span>
          <span className={"bold"}>{" Viewing Experience"}</span>
        </Title>

        <Row justify={"center"} style={{ paddingBottom: 16 }}>
          <div className={"zoom-img-wrapper"}>
            <img src={gearsImg} alt={""} />
          </div>
        </Row>

        <Paragraph centered color={"white"} style={{ paddingBottom: 16 }} weight={"w300"}>
          {
            "For optimal display and navigation\nplease set your browser zoom to 100%.\nDifferent zoom levels may affect layout and alignment."
          }
        </Paragraph>
        <Paragraph centered color={"orange"} size={"md"}>
          <span className={"bold"}>{"Quick tip:"}</span>
        </Paragraph>
        <Paragraph centered color={"website-secondary"} className={"tip-wrapper"} weight={"w300"}>
          {"Use Ctrl + 0 (Windows) or ⌘ + 0 (Mac) to reset zoom to default."}
        </Paragraph>
        <Row justify={"center"} style={{ width: "100%", paddingTop: 16 }}>
          <Col>
            <Checkbox checked={isChecked} onChange={onCheckboxChange} disabled={loading} />
            <Text color={"website-secondary"} size={"xs"} style={{ paddingLeft: 8 }}>
              {"Don't show again"}
            </Text>
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

export default ZoomNotice
